import { frontendURL } from '../../../../helper/URLHelper';

const campaigns = accountId => ({
  parentNav: 'campaigns',
  routes: ['list_campaigns_all','list_campaigns_draft', 'list_campaigns_scheduled','list_campaigns_in_progress','list_campaigns_completed','list_campaigns_failed'],
  menuItems: [
    {
      icon: 'circle',
      label: 'CAMPAIGNS-ALL',
      key: 'allCampaigns',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns-manager/campaign/all`),
      toStateName: 'list_campaigns_all',
    },
    {
        icon: 'circle',
        label: 'CAMPAIGNS-DRAFT',
        key: 'draftCampaigns',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/campaigns-manager/campaign/draft`),
        toStateName: 'list_campaigns_draft',
      },
      {
        icon: 'circle',
        label: 'CAMPAIGNS-SCHEDULED',
        key: 'scheduledCampaigns',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/campaigns-manager/campaign/scheduled`),
        toStateName: 'list_campaigns_scheduled',
      },
      {
        icon: 'circle',
        label: 'CAMPAIGNS-IN-PROGRESS',
        key: 'inProgressCampaigns',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/campaigns-manager/campaign/in-progress`),
        toStateName: 'list_campaigns_in_progress',
      },
      {
        icon: 'circle',
        label: 'CAMPAIGNS-COMPLETED',
        key: 'completedCampaigns',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/campaigns-manager/campaign/completed`),
        toStateName: 'list_campaigns_completed',
      },
      {
        icon: 'circle',
        label: 'CAMPAIGNS-FAILED',
        key: 'failedCampaigns',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/campaigns-manager/campaign/failed`),
        toStateName: 'list_campaigns_failed',
      },
    
  ],
});

export default campaigns;
